import classNames from 'classnames'
import BaseBreadcrumb from '../../breadcrumb'

const Breadcrumb = ({ ...attrs }) => {
  attrs.className = classNames(
    attrs.className,
    [
      'bg-white',
      'relative',
      'pb-20'
    ]
  )

  return <section {...attrs}>
    <div
      className={
        classNames([
          'relative',
          'container',
          'px-4'
        ])
      }>
      <BaseBreadcrumb
        items={[
          {
            text: 'Especializaciones',
            href: '/especializaciones/'
          }
        ]} />
    </div>
  </section>
}

export default Breadcrumb
